import endsWith from 'lodash/endsWith';

import { TLD } from '@front/common/src/types/country';
import { setCurrentCountry } from '@front/common/src/utils/country';
import {
  COUNTRIES_BY_DOMAIN,
  DEFAULT_COUNTRY,
  DEFAULT_LOCALE_BY_COUNTRY,
  DOMAINS_BY_COUNTRY,
  SUPPORTED_LOCALES,
} from '@front/common/src/constants/country';
import { uppercaseLastTwo } from '@front/common/src/utils/strings';

import { Locale } from '@front/i18n';

const isValidDomain = (domain: string | undefined): domain is TLD =>
  !!domain && Object.values(DOMAINS_BY_COUNTRY).includes(domain as TLD);

const getCurrentDomain = () =>
  Object.keys(COUNTRIES_BY_DOMAIN).find((domain) => endsWith(window.location.hostname, domain));

const getCountryByDomain = () => {
  const domain = getCurrentDomain();
  return isValidDomain(domain) ? COUNTRIES_BY_DOMAIN[domain] : DEFAULT_COUNTRY;
};

export const getWebAppLocale = () => {
  const localeFromPathname = uppercaseLastTwo(window.location.pathname.substring(1, 6)) as Locale;

  if (SUPPORTED_LOCALES.includes(localeFromPathname)) {
    return localeFromPathname;
  }

  return DEFAULT_LOCALE_BY_COUNTRY[getCountryByDomain()];
};

export const setCountry = () => {
  setCurrentCountry(getCountryByDomain());
};
